import React, { Fragment, useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Col,
    UncontrolledTooltip
} from 'reactstrap';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';

export default function AddNeeds(props) {
    const { receivers, setRefreshNeed } = props;
    const [modalAddNeed, setModalAddNeed] = useState(false);
    const toggleModalAddNeed = useCallback(() => {
        setModalAddNeed(!modalAddNeed);
    }, [setModalAddNeed, modalAddNeed]);

    const { register, handleSubmit, reset } = useForm({});
    const { currentGroup, toggleLoading } = useAuth();

    const onSubmitAddNeed = useCallback(
        async (data) => {
            if (!data.receiver || !data.need) {
                return;
            }
            toggleLoading(true);
            api.post('/ro.team.insertNeed', {
                receiverId: data.receiver,
                content: data.need,
                groupId: currentGroup.id,
            })
                .then((response) => {
                    toast.success(`Need added`);
                    toggleModalAddNeed();
                    reset(response);
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                    setRefreshNeed(true);
                });
        },
        [toggleModalAddNeed, reset, currentGroup.id, toggleLoading, setRefreshNeed]
    );

    return (
        <div>
            <Fragment>
                <Button
                    className="mb-2 mr-2 btn-icon btn-icon-only"
                    color="success"
                    onClick={toggleModalAddNeed}
                    id="addNeedId"
                >
                    <FontAwesomeIcon icon={faPlus} size="1x" />
                </Button>
                <UncontrolledTooltip
                    placement="left"
                    target={'addNeedId'}
                >
                    Add a Need
                </UncontrolledTooltip>

                <Modal isOpen={modalAddNeed} toggle={toggleModalAddNeed}>
                    <ModalHeader toggle={toggleModalAddNeed}>
                        Add Need
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup row>
                                <Label for="receiver" sm={2}>
                                    Senior
                                </Label>
                                <Col sm={10}>
                                    <select
                                        name="receiver"
                                        id="receiver"
                                        ref={register}
                                        className="form-control"
                                    >
                                        {receivers &&
                                            receivers.map((receiver) => (
                                                <option
                                                    value={receiver.id}
                                                    key={receiver.id}
                                                >
                                                    {receiver.name}
                                                </option>
                                            ))}
                                    </select>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="need" sm={2}>
                                    Need
                                </Label>
                                <Col sm={10}>
                                    <input
                                        type="text"
                                        name="need"
                                        id="need"
                                        ref={register}
                                        className="form-control"
                                    />
                                </Col>
                            </FormGroup>
                            <div className="text-center">
                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="success"
                                    onClick={handleSubmit(onSubmitAddNeed)}
                                >
                                    Add Need
                                </Button>

                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="primary"
                                    onClick={toggleModalAddNeed}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    </ModalBody>
                </Modal>
            </Fragment>
        </div>
    );
}
